import React, { useState, useEffect } from 'react';
import { APP_THEME } from '../theme/theme';
import { useNavigate } from 'react-router-dom';

function BannerCarousel({ bannerData = [] }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (!bannerData || bannerData.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % bannerData.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [bannerData]);

    const handleBannerClick = (redirectUrl) => {
        if (!redirectUrl) return;

        if (
            redirectUrl.startsWith("http://") ||
            redirectUrl.startsWith("https://")
        ) {
            window.location.href = redirectUrl;
        } else {
            navigate(`../${redirectUrl}`);
        }
    };

    if (!bannerData || bannerData.length === 0) {
        return (
            <div className="mx-4 mt-1">
                <div
                    className="w-full h-36 rounded-xl flex items-center justify-center"
                    style={{
                        background: APP_THEME.surfaceColor,
                        border: `1px solid ${APP_THEME.borderColor}`
                    }}
                >
                    <span style={{ color: APP_THEME.textSecondary }}>No banners available</span>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-4 mt-1">
            <div className="relative rounded-xl overflow-hidden">
                <div
                    className="relative cursor-pointer"
                    onClick={() => handleBannerClick(bannerData[currentIndex]?.redirect_url)}
                >
                    <img
                        src={bannerData[currentIndex]?.image_url}
                        alt="Banner"
                        className="w-full h-36 object-cover rounded-xl"
                        loading="lazy"
                    />
                </div>

                {/* Dots Indicator */}
                {bannerData.length > 1 && (
                    <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1.5">
                        {bannerData.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className="transition-all duration-200 rounded-full"
                                style={{
                                    width: currentIndex === index ? '8px' : '6px',
                                    height: currentIndex === index ? '8px' : '6px',
                                    backgroundColor: currentIndex === index
                                        ? APP_THEME.primaryColor
                                        : 'rgba(255,255,255,0.5)',
                                }}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default BannerCarousel;